import axios from '@/plugins/axios';
import { Response } from '@/types/common/Rest';
import { VUE_APP_GCN_SERVICES } from '@/constants';
import { handleApiResponse } from '@/utils/request';
import { FiltroParecer, PageParecer } from '../types';

const BASE_URL = `${VUE_APP_GCN_SERVICES}/publico/parecer`;

class ParecerService {
  public async consultarListaParecer(
    filtro: FiltroParecer
  ): Promise<Response<PageParecer>> {
    const url = `${BASE_URL}/find/all`;
    return handleApiResponse(() => axios.post(url, filtro));
  }
}

export default new ParecerService();
